var _effectorFileName = "/src/shared/lib/network/network.model.ts";
import { withFactory as _withFactory } from "effector";
import { trackNetworkStatus } from '@withease/web-api';
import { clientStarted } from '../startup';
export const {
  online,
  offline,
  $online,
  $offline
} = _withFactory({
  sid: "-k3sdz5",
  fn: () => trackNetworkStatus({
    setup: clientStarted
  }),
  name: "none",
  method: "trackNetworkStatus",
  loc: {
    file: _effectorFileName,
    line: 5,
    column: 54
  }
});